import z from 'zod';

const MAX_AGE = 140;
const MIN_AGE = 4;

export const birthdateValidator = z
  .date()
  .nullable()
  .optional()
  .refine(
    (date) => {
      if (!date) return true;
      const normalizedDate = new Date(date);
      normalizedDate.setHours(0, 0, 0, 0);
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      return normalizedDate <= now;
    },
    { message: 'Common.UpdatePersonalInfo.Errors.BirthDateInvalid' },
  )
  .refine(
    (date) => {
      if (!date) return true;
      const normalizedDate = new Date(date);
      normalizedDate.setHours(0, 0, 0, 0);
      const minDate = new Date();
      minDate.setFullYear(minDate.getFullYear() - MAX_AGE);
      minDate.setHours(0, 0, 0, 0);
      return normalizedDate >= minDate;
    },
    { message: 'Common.UpdatePersonalInfo.Errors.BirthDateInvalid' },
  )
  .refine(
    (date) => {
      if (!date) return true;
      const normalizedDate = new Date(date);
      normalizedDate.setHours(0, 0, 0, 0);
      const maxBirthDate = new Date();
      maxBirthDate.setFullYear(maxBirthDate.getFullYear() - MIN_AGE);
      maxBirthDate.setHours(0, 0, 0, 0);
      return normalizedDate <= maxBirthDate;
    },
    { message: 'Common.UpdatePersonalInfo.Errors.BirthDateMinAge' },
  );
